import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist()


export const lpaSecurityDetailsState = atom({
  key: 'lpaSecurityDetailsState',
  default: {
    LPAQuestions: [],
    responses: [],
    totalScore: []
  },
  effects_UNSTABLE: [persistAtom],
});